module.exports = __webpack_public_path__ + "icon_email-1346985c7aaceb601b0d4257133254f4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_email.svg
// module id = 260
// module chunks = 70